import React from 'react'

/*
  Note: loading="lazy" is added via `modify-oembed-atts.php`
  TODO: review if this is the best approach or if a custom lazy loading solution should be implemented
*/

// TODO: how to handle dnt parameter?

export default function Video({ video }: { video: string }) {
  return (
    <div className="component component--video">
      <div className="container @container">
        <div className="flex justify-center border-gradient gradient-angle-[to_bottom] @[0px]/single-simple:!border-0 @m-up:border-l @m-up:border-r">
          <div
            className="aspect-[16/9] w-full overflow-hidden rounded-md @m-up:max-w-[var(--container-s-max-w)]"
            dangerouslySetInnerHTML={{ __html: video }}></div>
        </div>
      </div>
    </div>
  )
}
